// Hook para obtener usuarios del CRM
// Usa React Query para caché, deduplicación y evitar double-fetch en StrictMode

import { useQuery } from '@tanstack/react-query';
import { crmService } from '@/services/crmService';
import type { CRMUser } from '@/types/crm';

/** Referencia estable para cuando no hay usuarios cargados */
const EMPTY_USERS: CRMUser[] = [];

export function useCRMUsers(filters?: { role?: string; isActive?: boolean; onlyResponsibles?: boolean }) {
  const useResponsiblesEndpoint = !!(
    filters?.onlyResponsibles ||
    (filters?.role && ['lawyer', 'agent', 'admin'].includes(filters.role))
  );

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['crm-users', filters?.role, filters?.isActive, filters?.onlyResponsibles],
    queryFn: async () => {
      if (useResponsiblesEndpoint) {
        const allUsers = await crmService.getResponsibleUsers(filters?.isActive ?? true, true);
        // Filtrar por rol si se especifica
        return filters?.role && ['lawyer', 'agent', 'admin'].includes(filters.role)
          ? allUsers.filter((u) => !u.role_name || u.role_name === filters.role)
          : allUsers;
      } else {
        const allUsers = await crmService.getUsers(filters?.isActive, true);
        return filters?.role
          ? allUsers.filter((u) => !u.role_name || u.role_name === filters.role)
          : allUsers;
      }
    },
    staleTime: 5 * 60 * 1000, // 5 min - la lista de usuarios no cambia frecuentemente
    retry: 1,
  });

  return {
    users: data ?? EMPTY_USERS,
    loading: isLoading,
    error: error as Error | null,
    refetch,
  };
}






